document.addEventListener('change', (e) => {
  if (!e.target.classList.contains('swatch-input__input')) return;

  const card = e.target.closest('.card-wrapper');
  if (!card) return;

  const mainImage = card.querySelector('.main-prod-image');
  if (!mainImage) return;

  const swatch = card.querySelector(`label[for="${e.target.id}"] .swatch`);
  if (!swatch) return;

  const bg = getComputedStyle(swatch)
    .getPropertyValue('--swatch--background')
    .trim();

  const match = bg.match(/url\(["']?(.*?)["']?\)/);

  if (!match) return;

  // Remove existing width parameter
  const baseUrl = match[1].replace(/([?&])width=\d+/g, '');

  // Set src
  mainImage.src = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}width=533`;

  // Set responsive srcset
  mainImage.srcset = `
    ${baseUrl}${baseUrl.includes('?') ? '&' : '?'}width=165 165w,
    ${baseUrl}${baseUrl.includes('?') ? '&' : '?'}width=360 360w,
    ${baseUrl}${baseUrl.includes('?') ? '&' : '?'}width=533 533w,
    ${baseUrl}${baseUrl.includes('?') ? '&' : '?'}width=720 720w,
    ${baseUrl} 3000w
  `.trim();
});